import { settings } from "../settings/settings";
/** Formats seconds as `Xs`, or `Xm Xs` / `Xh Xm Xs` when formatLongTimers is on. */
export const formatBuffTimer = (totalSeconds) => {
    if (!settings.formatLongTimers || totalSeconds < 60) {
        return `${totalSeconds}s`;
    }
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    if (hours > 0) {
        return `${hours}h ${minutes}m ${seconds}s`;
    }
    return `${minutes}m ${seconds}s`;
};
